import { Contract, MyProfileData, ContractDetails as TContractDetails, hasUnpaidAmmount } from 'cpfr-common';
import { Card, Notification } from '@vwfs-bronson/bronson-react';
import React, { useState } from 'react';
import { LicensePlate } from '../../license-plate/LicensePlate';
import { ContractDetails } from '../contract-details';
import { UnpaidAlertNotification } from '../unpaid-alert-notifications/UnpaidAlertNotification';
import { useTranslation } from 'react-i18next';

export const ContractComponent: React.FC<{
    contract: Contract & TContractDetails;
    defaultExpanded: boolean;
    isContactInformationChangePending: boolean;
    myProfile?: MyProfileData;
}> = ({ contract, defaultExpanded, isContactInformationChangePending, myProfile }) => {
    const { t } = useTranslation('contracts');
    const [showSuccessNotification, setShowSuccessNotification] = useState(false);
    const { contractNumber, productTypeFR = '', carModel = ' ', licensePlate = '', amountUnpaidNotPaid } = contract;

    return (
        <Card
            expandable
            title={carModel}
            titleLevel={3}
            contentShort={<LicensePlate registrationNumber={licensePlate} />}
            defaultExpanded={defaultExpanded}
            className={'u-mb'}
            aria-label={t('contract-details-aria-label')}
            contentLarge={
                <ContractDetails
                    contract={contract}
                    isContactInformationChangePending={isContactInformationChangePending}
                    setShowSuccessNotification={setShowSuccessNotification}
                />
            }
        >
            <>
                {showSuccessNotification && (
                    <Notification
                        title={t('success-notification.title')}
                        className="u-mb"
                        visible
                        testId="contract-success-notification"
                        showCloseButton={false}
                        status={'success'}
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t('success-notification.text'),
                            }}
                        />
                    </Notification>
                )}
                <p className="c-card__subtitle">
                    {`Type de financement: ${productTypeFR}`} <br aria-hidden="true" />{' '}
                    {`N° dossier: ${contractNumber}`}
                </p>
                {hasUnpaidAmmount(contract) && (
                    <UnpaidAlertNotification
                        amountUnpaidNotPaid={amountUnpaidNotPaid as number}
                        myProfile={myProfile}
                        contractId={contract?.refId?.toString()}
                    />
                )}
            </>
        </Card>
    );
};
